import { HttpAgent } from '@dfinity/agent'
import { Principal } from '@dfinity/principal'
import { LedgerCanister, AccountIdentifier, SubAccount } from '@dfinity/ledger-icp'
import { IcrcLedgerCanister } from '@dfinity/ledger-icrc'
import getTokenActor from './getTokenActor'

const getTokenBalance = async (
  canisterId: string,
  standard: string,
  agent: HttpAgent,
  principal: string,
  subaccount?: number[] | Uint8Array
) => {
  switch (standard) {
    case 'ICP':
      const icpLedger = LedgerCanister.create({
        agent,
        canisterId: Principal.fromText(canisterId),
      })

      // https://github.com/dfinity/ic-js/issues/934
      const subAccount = subaccount && SubAccount.fromBytes(Uint8Array.from(subaccount))
      if (subAccount instanceof Error) {
        throw 'Failed to instantiate subaccount'
      }

      const accountIdentifier = AccountIdentifier.fromPrincipal({
        principal: Principal.fromText(principal),
        subAccount,
      })
      return icpLedger.accountBalance({
        accountIdentifier,
      })
    case 'ICRC1':
    case 'ICRC2':
    case 'ICRC3':
      const icrcLedger = IcrcLedgerCanister.create({
        agent,
        canisterId: Principal.fromText(canisterId),
      })

      return icrcLedger.balance({
        owner: Principal.fromText(principal),
        subaccount,
      })
    default:
      const actor = getTokenActor(canisterId, standard, agent)

      if (actor.dip20) {
        return actor.dip20.balanceOf(Principal.fromText(principal))
      }

      if (actor.drc20) {
        return actor.drc20.drc20_balanceOf(principal)
      }

      if (actor.xtc) {
        return actor.xtc.balanceOf(Principal.fromText(principal))
      }

      return Promise.reject('Unsupported token')
  }
}

export default getTokenBalance
